import {IconProps} from "../../types/types";

export default function CheckRoundIcon({
    size,
    color="#2CBF68",
    ...props
                                       }:Omit<IconProps, 'width'|'height'>) {
    return <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_418_7699)">
            <path
                d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z"
                fill={color} stroke={color} strokeLinecap="round"/>
            <path
                d="M10.6867 5.97994C10.882 6.1752 10.882 6.49179 10.6867 6.68705L7.35339 10.0204C7.15813 10.2156 6.84155 10.2156 6.64628 10.0204L5.31295 8.68705C5.11769 8.49179 5.11769 8.1752 5.31295 7.97994C5.50821 7.78468 5.8248 7.78468 6.02006 7.97994L6.99984 8.95972L8.48973 7.46983L9.97962 5.97994C10.1749 5.78468 10.4915 5.78468 10.6867 5.97994Z"
                fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_418_7699">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>

}